<div class="pb-2 mb-3 border-bottom">
  <h3>
    <b>Encryption Key availability</b>
  </h3>
</div>
<div *ngIf="!availableKeys && !loading" class="alert alert-warning alert-dismissible fade show">
  Keys not available.
</div>
<div *ngIf="availableKeys && !loading">
  <h6 style="text-align: center">
    Week - {{ weekDisplayed }}
  </h6>
  <p-table [rowHover]="true" [tableStyle]="{'table-layout':'auto'}" [value]="keysInformation"
           id="qed-multicast-table">
    <ng-template pTemplate="header">
      <tr>
        <th rowspan="2" style="text-align: center">Channels</th>
        <th [attr.colspan]="pops.length" style="text-align: center">POPs</th>
      </tr>
      <tr>
        <th *ngFor="let pop of pops"><span [pTooltip]="technicalPopService.getCageTooltip(pop | uppercase )">{{ pop | uppercase }} </span></th>
      </tr>
    </ng-template>
    <ng-template [ngForOf]="keysInformation" let-keyInformation ngFor pTemplate="body">
      <tr>
        <td>{{ keyInformation['channel'] }}</td>
        <td (click)="displayItem($event, keyInformation, pop, op1)"
            *ngFor="let pop of pops">
          {{ keyInformation['pops'][pop] ? keyInformation['pops'][pop]['prod'] ? keyInformation['pops'][pop]['prod'] : '' : '' }}
        </td>
      </tr>
    </ng-template>
  </p-table>
  <p-overlayPanel #op1 [dismissable]="true" appendTo="body">
    <div class="item-info">
      <p><b>Channel => {{ channelSelected }} / POP => {{ popSelected }}</b></p>
      <span>Number of <b>PROD</b> keys: {{ numberOfProdKeys }}</span><br>
      <span>Number of <b>UAT</b> keys: {{ numberOfUatKeys }}</span>
    </div>
  </p-overlayPanel>
</div>
